import "./NotificationModal.css";

const EmailWarningModal = ({ isOpen, onUseExisting, onEnterNew, email }) => {
  if (!isOpen) return null;

  return (
    <div className="notification-modal-overlay" onClick={onEnterNew}>
      <div
        className="notification-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="notification-modal-close" onClick={onEnterNew}>
          ×
        </button>

        <div className="notification-modal-icon warning">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="75"
            height="75"
            viewBox="0 0 75 75"
            fill="none"
          >
            <circle
              cx="37.5"
              cy="37.5"
              r="35"
              stroke="#F5A623"
              strokeWidth="5"
              fill="none"
            />
            <line
              x1="37.5"
              y1="20"
              x2="37.5"
              y2="45"
              stroke="#F5A623"
              strokeWidth="5"
              strokeLinecap="round"
            />
            <circle cx="37.5" cy="55" r="3" fill="#F5A623" />
          </svg>
        </div>

        <div className="notification-modal-text">
          <h2 className="notification-modal-title">Email Already Registered</h2>
          <p className="notification-modal-message">
            The email <strong>{email}</strong> is already registered in our
            system. Would you like to Use the existing data on system or
            Register again with new details.
          </p>
        </div>

        <div className="email-warning-modal-actions">
          <button
            className="email-warning-modal-btn secondary"
            onClick={onEnterNew}
          >
            Enter New Details
          </button>
          <button
            className="email-warning-modal-btn primary"
            onClick={onUseExisting}
          >
            Use Existing Data
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailWarningModal;
